import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { RenderFormFields } from "src/components/RenderFormFields";
import { StepControls } from "../StepControls";
import { INTERNATIONAL_FIELD } from "../constants/fields";
import { registrationDescriptionsTrns, registrationTitlesTrns } from "../trns";
import { StepControlsProps } from "../types";

interface Props extends StepControlsProps {}

export const PresentedInternationally: FC<Props> = ({
  ...stepControlsProps
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-col gap-5 md:gap-10">
        <div className="flex flex-col gap-3">
          <h2 className="font-semibold">
            {t(registrationTitlesTrns.internationalMarket)}
          </h2>
          <p>{t(registrationDescriptionsTrns.internationalMarketDesc)}</p>
        </div>
        <div>
          <RenderFormFields fields={INTERNATIONAL_FIELD} />
        </div>
      </div>
      <StepControls {...stepControlsProps} />
    </div>
  );
};
